import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IFeedbackResponse } from 'src/app/share/entities/api-response';
import { IActionMethodModel, IFeedbackModel } from 'src/app/share/entities/data-model';
import { IActionModel } from 'src/app/share/entities/data-view';
import { IDataPanelViewModel, IStatViewModel, IViewData } from 'src/app/share/entities/view-model';
import { IPageDataViewModel } from 'src/app/share/pages/pages';
import { AuthService } from 'src/app/share/services/auth.service';
import { CommonService } from 'src/app/share/services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-live-gps',
  templateUrl: './live-gps.component.html',
  styleUrls: ['./live-gps.component.scss']
})
export class LiveGpsComponent implements OnInit {

  constructor(private commonService: CommonService, private authService: AuthService, private http: HttpClient) { }

  vm$: Observable<any>
  fb: IFeedbackModel = {

  };

  private liveGpsExecute$(): Observable<IPageDataViewModel> {
    return this.commonService.getData('PageCommand', 'live.gps', 'page-load').pipe(
      map((v: IViewModelLiveGps) => {
        if (v.workingText)
          return { ...v };

        const ret = { ...v, actionsAllowed: true };
        //console.log(ret.data);
        if (ret.data) {
          // stat panel 
          ret.statPanelVm = ret.data.statPanel ? {
            data: ret.data.statPanel
          } : null;

          ret.corpGPSPanellVm = ret.data.corpGPSPanel && !ret.data.corpGPSPanel.unauthorized ? {
            data: ret.data.corpGPSPanel,
            rows: ret.data.corpGPSPanel.rows.map(r => ({ code: r[0], actionTitle: "Ticket", fields: r })),
            rowsFiltered: ret.data.corpGPSPanel.rows.map(r => ({ code: r[0], actionTitle: "Ticket", fields: r })),
            styleTypes: ret.data.corpGPSPanel.styleTypes,
            styleTypesFiltered: ret.data.corpGPSPanel.styleTypes,
            //actions: [
            //  { name: "Ticket", code: "doTicket" },
            //  { name: "Ignore", code: "doIgnore" },
            //  { name: "Validate", code: "doValidate" }
            //],
            select: {
              selectValue: -1,
              onSelect: this.onSelect,
              options: [
                { value: -1, label: 'Select GPS Thresholds' },
                { value: 0, label: 'All' },
                { value: 1, label: 'No GPS' },
                { value: 2, label: 'More Then 5 min' },
                { value: 3, label: 'More Then 15 min' },
                { value: 4, label: 'More Then 30 min' },
              ]
            }
          } : undefined;

          ret.farmoutGPSPanelVm = ret.data.farmoutGPSPanel && !ret.data.farmoutGPSPanel.unauthorized ? {
            data: ret.data.farmoutGPSPanel,
            rows: ret.data.farmoutGPSPanel.rows.map(r => ({ code: r[0], actionTitle: "Ticket", fields: r })),
            rowsFiltered: ret.data.farmoutGPSPanel.rows.map(r => ({ code: r[0], actionTitle: "Ticket", fields: r })),
            styleTypes: ret.data.farmoutGPSPanel.styleTypes,
            styleTypesFiltered: ret.data.farmoutGPSPanel.styleTypes,
            //actions: [
            //  { name: "Ticket", code: "doTicket" },
            //  { name: "Ignore", code: "doIgnore" },
            //   { name: "Validate", code: "doValidate" }
            //],
            select: {
              selectValue: -1,
              onSelect: this.onSelect,
              options: [
                { value: -1, label: 'Select GPS Thresholds' },
                { value: 0, label: 'All' },
                { value: 1, label: 'No GPS' },
                { value: 2, label: 'More Then 5 min' },
                { value: 3, label: 'More Then 15 min' },
                { value: 4, label: 'More Then 30 min' },
              ]
            }
          } : undefined;

          ret.drVehAssignmentDupPanelVm = ret.data.drVehAssignmentDupPanel && !ret.data.drVehAssignmentDupPanel.unauthorized ? {
            data: ret.data.drVehAssignmentDupPanel,
            rows: ret.data.drVehAssignmentDupPanel.rows.map(r => ({ code: r[0], actionTitle: "Ticket", fields: r })),
            rowsFiltered: ret.data.drVehAssignmentDupPanel.rows.map(r => ({ code: r[0], actionTitle: "Ticket", fields: r })),
            styleTypes: ret.data.drVehAssignmentDupPanel.styleTypes,
            styleTypesFiltered: ret.data.drVehAssignmentDupPanel.styleTypes,
            //actions: [
            //  { name: "Ticket", code: "doTicket" },
            //  { name: "Ignore", code: "doIgnore" },
            //  { name: "Validate", code: "doValidate" }
            //]
          } : undefined;

          ret.wrongVehiclesPanelVm = ret.data.wrongVechiclesPanel && !ret.data.wrongVechiclesPanel.unauthorized ? {
            data: ret.data.wrongVechiclesPanel,
            rows: ret.data.wrongVechiclesPanel.rows.map(r => ({ code: r[0], actionTitle: "Ticket", fields: r })),
            rowsFiltered: ret.data.wrongVechiclesPanel.rows.map(r => ({ code: r[0], actionTitle: "Ticket", fields: r })),
            styleTypes: ret.data.wrongVechiclesPanel.styleTypes,
            styleTypesFiltered: ret.data.wrongVechiclesPanel.styleTypes,
            actions: []
          } : undefined;

          ret.mapVm = ret.data.corpGPSPanel && !ret.data.corpGPSPanel.unauthorized ? this.mapVm(ret.data.liveMap) : undefined
        }

        return ret;
      })
    );
  }

  /**
   * 
   * @returns 
   */
  private mapVm(data: IApiMapShowTripsResult): IMapViewModel {
    if (!data)
      return undefined;
    
    if (data.loadError)
      return { data: data, errorText: data.loadError };

    const markerItems = (data.segments || []).map(s => {
      return {
        segment: s
      };
    });

    // handle api data
    const markers = markerItems.map(mi => {
      const marker: IMapMarker = {
        latitude: mi.segment.latitude, longitude: mi.segment.longitude,
        
        title: mi.segment.confirmNumber,

        details: [
          {
            title: 'Info',
            rows: [
              { value: mi.segment.customer, title: 'Customer' },
              { value: mi.segment.pickupDateTime, title: 'PU Date / Time' },
              { value: mi.segment.vehicleCode, title: 'Vehicle' },
              { value: mi.segment.tripStatus, title: 'Status' }
            ]
          }
        ]
      };
      return marker;
    });
    
    const centerPoint = markers.length == 0 ? undefined
      : {
        latitude: markers.map(m => m.latitude).sort((a, b) => Math.abs(a) - Math.abs(b))[0] /* lowest */,
        longitude:markers.map(m => m.longitude).sort((a, b) => Math.abs(b) - Math.abs(a))[0] /* highest */
      };
    
    const ret: IMapViewModel = {
      data: data,

      markers: markers,
      centerPoint: centerPoint
    };
    return ret;
  }

  ngOnInit() {
    this.vm$ = this.liveGpsExecute$();
  }

  /**
   * 
   */
  refreshPage() {
    this.vm$ = this.liveGpsExecute$();
    this.authService.userInRole;
  }

  /**
   * 
   */
  putTicket(am: IActionModel) {

    this.fb.resNumber = am.code;
    this.fb.subject = "[ECLSweb 2.0 Rate Issue] " + am.section;
    this.fb.userName = am.userName;
    this.fb.addToTrackTable = true;

    const s = this.http.post(`${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/SantaCruz/SubmitFeedback`, this.fb).subscribe(
      (next: IFeedbackResponse) => {
        console.log(next);
        next.success == true ? this.fb.successText = 'Thank You' : this.fb.errorText = next.message;
      },
      (err: any) => {
        console.log(err);
        this.fb.errorText = err.message || err;
        this.fb.workingText = undefined;
      },
      () => {
        s.unsubscribe();
        this.fb.workingText = undefined;
        this.refreshPage();
      });
  }

  /**
   * 
   */
  doAction(action: IActionMethodModel) {
    //console.log('parent action: ', action.name)
  }

  onSelect(vm: IDataPanelViewModel, value: any) {

    const maxOption = vm.select.options.reduce((op, item) => op = op > item.value ? op : item.value, 0);

    if (!value || value <= 0 || value > maxOption) {
      vm.rowsFiltered = vm.rows;
      vm.styleTypesFiltered = vm.styleTypes;
      return;
    }

    const sortCol = 4;
    vm.rowsFiltered = [];
    vm.styleTypesFiltered = [];
    vm.rows.forEach((r, idx) => {

      if (value == 1 /* No GPS */ && r.fields[sortCol].length == 0) {
        vm.rowsFiltered.push(r);
        if (vm.styleTypes && vm.styleTypes.length >= idx)
          vm.styleTypesFiltered.push(vm.styleTypes[idx]);
      } else if (value == 2 /* More Then 5 min */) {
        if (!isNaN(parseInt(r.fields[sortCol])) && parseInt(r.fields[sortCol]) >= 5) {
          vm.rowsFiltered.push(r);
          if (vm.styleTypes && vm.styleTypes.length >= idx)
            vm.styleTypesFiltered.push(vm.styleTypes[idx]);
        }
      } else if (value == 3 /* More Then 15 min */) {
        if (!isNaN(parseInt(r.fields[sortCol])) && parseInt(r.fields[sortCol]) >= 15) {
          vm.rowsFiltered.push(r);
          if (vm.styleTypes && vm.styleTypes.length >= idx)
            vm.styleTypesFiltered.push(vm.styleTypes[idx]);
        }
      } else if (value == 4 /* More Then 30 min */) {
        if (!isNaN(parseInt(r.fields[sortCol])) && parseInt(r.fields[sortCol]) >= 30) {
          vm.rowsFiltered.push(r);
          if (vm.styleTypes && vm.styleTypes.length >= idx)
            vm.styleTypesFiltered.push(vm.styleTypes[idx]);
        }
      }
    });
  }
}

/**
 * 
 */
interface IViewModelLiveGps extends IPageDataViewModel {
  data?: {
    statPanel: any;
    corpGPSPanel: IViewData;
    farmoutGPSPanel: IViewData;
    drVehAssignmentDupPanel: IViewData;
    wrongVechiclesPanel: IViewData;
    liveMap?: IApiMapShowTripsResult;
  };

  statPanelVm: IStatViewModel;
  corpGPSPanellVm: IDataPanelViewModel;
  farmoutGPSPanelVm: IDataPanelViewModel;
  drVehAssignmentDupPanelVm: IDataPanelViewModel;
  wrongVehiclesPanelVm: IDataPanelViewModel;

  mapVm?: IMapViewModel;

  actionsAllowed?: boolean;
}


/**
 * 
 */
interface IMapViewModel {
  data: IApiMapShowTripsResult;
  errorText?: string;

  centerPoint?: IMapLatLng;
  markers?: IMapMarker[];
}

/**
 * 
 */
interface IMapLatLng {
  latitude: number;
  longitude: number;
}

/**
 * 
 */
interface IMapMarker extends IMapLatLng {
  title?: string;

  details: {
    title: string;
    rows: { title: string, value: string }[];
  }[];
}

/**
 * 
 */
interface IApiMapShowTripsResult {
  loadError?: string;
  segments?: {
    confirmNumber: string;
    customer: string;
    vehicleCode: string;
    pickupState: string;
    tripStatus: string;
    pickupDateTime: string;
    latitude: number;
    longitude: number;
  }[];
}